<template>
  <div
    class="chat-answer chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    {{ message.DATA_TEXT }}
  </div>
</template>

<script>
import MessageDate from '../MessageDate.vue';

export default {
  name: 'AnswerItem',
  components: {
    MessageDate,
  },
  props: ['message'],
};
</script>

<style></style>
